module.exports = __webpack_public_path__ + "static/media/Grupo2mg.88bfbe3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/img-on-satelital/Grupo2mg.png
// module id = 92
// module chunks = 0